<template>
  <el-dialog title="添加费用标准" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item label="费用名称" prop="feeName">
        <el-input v-model="form.feeName" placeholder="必填，请填写费用名称" />
      </el-form-item>

      <el-form-item label="费用类型" prop="feeTypeCd">
        <el-select v-model="form.feeTypeCd" placeholder="必填，请填写费用类型" style="width:100%">
          <el-option v-for="item in feeTypes" :key="item.feeTypeCd" :label="item.typeName" :value="item.feeTypeCd" />
        </el-select>
      </el-form-item>

      <el-form-item label="计算公式" prop="computingFormula">
        <el-select v-model="form.computingFormula" placeholder="必填，请选择计算公式" style="width:100%"
          @change="handleFormulaChange">
          <el-option value="2002" label="固定费用" />
          <el-option value="3003" label="费用面议" />
        </el-select>
      </el-form-item>

      <el-form-item label="单价" prop="feePrice" v-if="form.computingFormula === '2002'">
        <el-input v-model="form.feePrice" placeholder="必填，请填写单价" />
      </el-form-item>

      <el-form-item label="市场价" prop="marketPrice">
        <el-input v-model="form.marketPrice" placeholder="请输入市场价" />
      </el-form-item>

      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker v-model="form.startTime" type="datetime" placeholder="必填，请填写开始时间"
          value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
      </el-form-item>

      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker v-model="form.endTime" type="datetime" placeholder="必填，请填写结束时间"
          value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
      </el-form-item>

      <el-form-item label="默认费用" prop="isDefault">
        <el-select v-model="form.isDefault" placeholder="必填，请选择" style="width:100%">
          <el-option value="F" label="是" />
          <el-option value="T" label="否" />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveHousekeepingFeeConfig,queryHousekeepingFeeType } from '@/api/housekeeping/housekeepingFeeConfigApi'

import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddHousekeepingFeeConfig',

  data() {
    return {
      feeTypes: [],
      dialogVisible: false,
      form: {
        feeName: '',
        feeTypeCd: '',
        computingFormula: '',
        feePrice: '',
        marketPrice: '',
        startTime: '',
        endTime: '',
        isDefault: '',
        shopId: ''
      },
      rules: {
        feeName: [
          { required: true, message: '费用名称不能为空', trigger: 'blur' },
          { max: 128, message: '费用名称太长', trigger: 'blur' }
        ],
        feeTypeCd: [
          { required: true, message: '费用类型不能为空', trigger: 'change' }
        ],
        computingFormula: [
          { required: true, message: '计算公式不能为空', trigger: 'change' }
        ],
        feePrice: [
          { required: true, message: '单价不能为空', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '开始时间不能为空', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '结束时间不能为空', trigger: 'change' }
        ],
        isDefault: [
          { required: true, message: '是否默认费用不能为空', trigger: 'change' }
        ],
        marketPrice: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '市场价格式不正确，最多两位小数', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.form.shopId = getShopId()
      this._listHousekeepingFeeTypes()
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    handleFormulaChange(val) {
      if (val !== '2002') {
        this.form.feePrice = '0'
      }
    },

    async _listHousekeepingFeeTypes() {
      try {
        const params = {
          page: 1,
          row: 50,
          shopId: getShopId()
        }
        const res = await queryHousekeepingFeeType(params)
        this.feeTypes = res.data
      } catch (error) {
        console.error('获取费用类型失败:', error)
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        if (this.form.computingFormula === '2002' && !this.form.feePrice) {
          this.$message.warning('请填写单价')
          return
        }

        try {
          await saveHousekeepingFeeConfig(this.form)
          this.$message.success('添加成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          this.$message.error(error)
          console.error('添加失败:', error)
        }
      })
    }
  }
}
</script>